import type { FaireProductEntity } from "../../entity_types/product";

export const p_yn8raebvcj: FaireProductEntity = {
  token: "p_yn8raebvcj",
  type: "product",
  name: "Creamy Pistachio Spread",
  brandToken: "b_dgkt7t7qa8",
  brandName: "Pistakio",
  imageUrl:
    "https://cdn.faire.com/fastly/402b8c0b4d6c6a4e10d4ec42cc09ca795464cafb734a678ed28966d8c50f95f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50a69923668255638997af41951ddc6525614459b3f9a45076a977b3a7dfb737.webp",
    "https://cdn.faire.com/fastly/0b7bee3c03fb37086d2269e570214d8e07bfe400a885dd40d3ec06674d01c0f3.webp",
    "https://cdn.faire.com/fastly/5e034aa3f380f0df6c4c8ab013184dc2b278e973a4e4da1c87c42c86bbfdfb83.webp",
    "https://cdn.faire.com/fastly/a9578e10213475ff4bfdbfcf94f568a4654f8b140460d36ae373277dc6119136.webp",
  ],
  priceDollars: 9.5,
  description:
    "a drizzable, irresistibly creamy pistachio spread made with real pistachios (no artificial flavors or colors!) and other natural ingredients. it’s crafted to deliver the creamiest pistachio experience you’ve ever tasted — bold pistachio flavor, insanely smooth texture, and total spoon-licking satisfaction.\n\nhere’s why you (and your customers) will love it:\n\n— the creamiest pistachio spread you’ll ever try. people call it “crack in a jar” — imagine if pistachio butter and Nutella had a silkier, better-for-you baby. unlike traditional nut butters, it doesn’t stick to your mouth. it’s irresistibly smooth, perfectly drizzable, and made with real ingredients (yes…real pistachios as the first ingredient).\n— it makes everything taste better. this spread doesn’t just sit on a spoon — it flows. drizzle it into morning coffee, slather it on toast, swirl it over ice cream, dip fruit, or pair it with cheese. if it can use creaminess, this elevates it.\n— pure pistachio flavor, without the luxury price tag. it actually tastes like pistachios — rich, nutty, and deeply satisfying — while staying accessible enough to become a daily pantry staple.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:10.689Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
